import { RootState } from "../redux/reducers";
import { store } from "../redux/store";
import httpService from "./httpService";
import { CreateProductDto, PaymentLinkDto, ProductDto, UpdateProductDto } from "./model/marketplace.model";

export async function createProduct(createProductDto: CreateProductDto): Promise<ProductDto> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .post<ProductDto>(`/marketplace/products/${selectedBusiness}`, createProductDto)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function updateProduct(productId: string, updateProductDto: UpdateProductDto): Promise<ProductDto> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .put<ProductDto>(`/marketplace/products/${selectedBusiness}/${productId}`, updateProductDto)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function deleteProduct(productId: string): Promise<void> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .delete(`/marketplace/products/${selectedBusiness}/${productId}`)
        .then(() => {})
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getProducts(): Promise<ProductDto[]> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<ProductDto[]>(`/marketplace/products/${selectedBusiness}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getPaymentLink(productId: string): Promise<PaymentLinkDto> {
    return httpService
        .get<PaymentLinkDto>(`/marketplace/products/${productId}/payment-link`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}
